const types = {
  ADD_LIST_FUNCTIONS: "ADD_LIST_FUNCTIONS",
};

const addListFunctions = data => {
  return {
    type: types.ADD_LIST_FUNCTIONS,
    payload: data
  };
};

export default {
  types,
  addListFunctions
};
